import { ApolloClient } from "@apollo/client";
import { Auth0ContextInterface, User } from "@auth0/auth0-react";
import JWT from "jwt-client";
import runtimeConfig from "../runtimeConfig";

import { disconnectSubscriptionClient } from "./apolloClient";

export { default as apolloClient } from "./apolloClient";

export const logout = (
  apolloClient: ApolloClient<unknown>,
  auth0: Auth0ContextInterface<User>
): void => {
  JWT.forget();
  apolloClient.clearStore();
  disconnectSubscriptionClient();

  const partnerAuth = runtimeConfig.partnerAuth;

  if (partnerAuth === "LV") {
    auth0.logout();
  }
};
